<template>
  <div>
    <div class="article-header-container">
      <courseHeader />
      <div class="row article-header-wrapper">
        <div class="col-1"></div>
        <div class="col-lg-5 col-12 article-header-text">
          <h1 class="article-header-title">{{ data?.fields?.title }}</h1>
          <div class="article-header-author">{{ data?.fields?.author }}</div>
          <div class="article-header-date">
            Reading time: {{ readingTime }} minute{{
              readingTime > 1 ? "s" : ""
            }}
          </div>
          <div class="article-header-date">
            {{ data?.fields?.blogDate && dateFormat(data?.fields?.blogDate) }}
          </div>
          <div class="article-header-date">
            {{ data?.fields?.eventDate && dateFormat(data?.fields?.eventDate) }}
          </div>
          <div
            class="article-header-icons"
            v-if="
              data?.fields?.author ||
              data?.fields?.blogDate ||
              data?.fields?.eventDate
            "
          >
            <img
              src="https://firebasestorage.googleapis.com/v0/b/comligo-website-v2.appspot.com/o/Facebook.png?alt=media&token=a851e024-e91f-4f0e-be88-3d2ad7ea2450"
              alt="facebook"
              class="header-icons"
              @click="openLink('https://www.facebook.com/ComligoSpanish')"
            />
            <img
              src="https://firebasestorage.googleapis.com/v0/b/comligo-website-v2.appspot.com/o/Linkedin.png?alt=media&token=33add9a2-3a02-4905-b20c-12940c6e43e7"
              alt="linkedin"
              class="header-icons"
              @click="
                openLink(
                  'https://www.linkedin.com/company/learnspanishonlinecomligo'
                )
              "
            />
            <img
              src="https://firebasestorage.googleapis.com/v0/b/comligo-website-v2.appspot.com/o/Instagram.png?alt=media&token=c51c5dbf-8cb1-47c4-9455-d63e80ffbb0f"
              alt="instagram"
              class="header-icons"
              @click="openLink('https://www.instagram.com/comligo/?hl=en')"
            />
          </div>
        </div>
        <div class="col-lg-6 col-12">
          <div class="articles-image-wrapper">
            <img
              v-if="imageUrl"
              :src="imageUrl"
              alt="template image"
              class="articles-image"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import courseHeader from "@/components/courseHeader.vue";
import axios from "axios";
import dayjs from "dayjs";

export default {
  name: "articleHeader",
  props: ["data"],
  components: {
    courseHeader,
  },
  data() {
    return {
      imageUrl: "",
      readingTime: 0,
    };
  },
  watch: {
    data() {
      this.getImageURL(this.data?.fields?.headerImage?.sys?.id);
    },
  },
  mounted() {
    this.getImageURL(this.data?.fields?.headerImage?.sys?.id);
    this.calculateWordCount();
  },
  methods: {
    getImageURL(assetId) {
      if (assetId) {
        axios
          .get(
            `https://cdn.contentful.com/spaces/8nqnktj51aoq/assets/${assetId}?access_token=njkIU16uuU7MPa5hOvzUO4deV6DFYht3xdwj6KUge-k`
          )
          .then((response) => {
            this.imageUrl = `https:${response.data.fields.file.url}`;
          });
      }
    },
    openLink(link) {
      window.open(`${link}`, "_blank").focus();
    },
    dateFormat(date) {
      return dayjs(date).format("MMMM DD, YYYY");
    },
    calculateWordCount() {
      const articleText = document.querySelector(
        ".article-body-right"
      ).innerText;
      const wordCount = articleText.split(/\s+/).length;
      const averageReadingSpeed = 200;
      this.readingTime = Math.ceil(wordCount / averageReadingSpeed);
      console.log(this.readingTime);
    },
  },
};
</script>

<style></style>
